// src/sectors/pilates/sms/components

import React, { useMemo, useState } from 'react';
import Divider from '@mui/material/Divider';
import Icon from '@mui/material/Icon';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Alert from '@mui/material/Alert';

import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDButton from 'components/MDButton';

import { SoftCard } from '../ui/SoftCard';
import { SmsTabBlockedList } from './tabs/SmsTabBlockedList';
import { SmsTabInboundMessages } from './tabs/SmsTabInboundMessages';
import { SmsTabSettings } from './tabs/SmsTabSettings';
import { SmsTabLastMessages } from './tabs/SmsTabLastMessages';
import { SmsTabTemplates } from './tabs/SmsTabTemplates';

function TabPanel({ value, index, children }) {
  if (value !== index) return null;
  return <MDBox mt={2}>{children}</MDBox>;
}

function ManagementHeaderActions({ gate, disabled }) {
  if (gate.noQuota) {
    return (
      <MDButton variant="gradient" color="info" startIcon={<Icon>shopping_cart</Icon>}>
        Kota Satın Al
      </MDButton>
    );
  }
}

export function SmsManagementCard({ sms, refreshSettings }) {
  const [tab, setTab] = useState(0);

  const disabled = sms?.gate?.closed || sms?.gate?.noQuota;

  const disabledAlertText = useMemo(() => {
    if (!disabled) return '';
    return sms?.gate?.closed
      ? 'sms modülü kapalı olduğu için yönetim alanı devre dışı.'
      : 'Mesaj hakkınız olmadığı için yönetim alanı devre dışı.';
  }, [disabled, sms?.gate?.closed]);

  return (
    <SoftCard sx={{ p: 0 }}>
      {/* Header */}
      <MDBox px={2} pt={2} pb={1} display="flex" alignItems="center" justifyContent="space-between">
        <MDTypography variant="h6" fontWeight="bold">
          Yönetim
        </MDTypography>

        <MDBox display="flex" gap={1}>
          <ManagementHeaderActions gate={sms?.gate || {}} disabled={disabled} />{' '}
        </MDBox>
      </MDBox>

      <Divider />

      {/* Disabled banner */}
      {disabled && (
        <MDBox px={2} pt={2}>
          <Alert severity={sms?.gate?.closed ? 'warning' : 'error'}>{disabledAlertText}</Alert>
        </MDBox>
      )}

      {/* Tabs */}
      <MDBox px={2} pt={1}>
        <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ opacity: disabled ? 0.55 : 1 }}>
          <Tab disabled={disabled} label="Ayarlar" icon={<Icon>tune</Icon>} iconPosition="start" />
          <Tab
            disabled={disabled}
            label="Son Mesajlar"
            icon={<Icon>history</Icon>}
            iconPosition="start"
          />

          <Tab
            disabled={disabled}
            label="Engellenenler"
            icon={<Icon>block</Icon>}
            iconPosition="start"
          />
        </Tabs>
      </MDBox>

      {/* Content wrapper (disable click) */}
      <MDBox
        px={2}
        pb={2}
        sx={{
          opacity: disabled ? 0.55 : 1,
          pointerEvents: disabled ? 'none' : 'auto',
        }}
      >
        <TabPanel value={tab} index={0}>
          <SmsTabSettings sms={sms} refreshSettings={refreshSettings} />
        </TabPanel>

        <TabPanel value={tab} index={1}>
          <SmsTabLastMessages sms={sms} />
        </TabPanel>

        <TabPanel value={tab} index={2}>
          <SmsTabBlockedList sms={sms} />
        </TabPanel>
        <TabPanel value={tab} index={3}>
          <SmsTabBlockedList sms={sms} />
        </TabPanel>

        <TabPanel value={tab} index={4}>
          <SmsTabInboundMessages sms={sms} />
        </TabPanel>
      </MDBox>
    </SoftCard>
  );
}
